<template>
  <table-view
    ref="tableView"
    url="/quantityNumber/info/mixingTable/list"
    :filterable="false"
    :filter-form="dataForm"
    :exportable="isAuthed('quantity_station_export')"
    export-url="/quantityNumber/info/mixingTable/download"
    export-file-name="拌站方量报表"
    :paging="false"
    show-index
    single
    :table-props="{
      'row-class-name': getCellClassName
    }"
  >
    <el-form slot="search" @keyup.enter.native="query" inline>
      <el-select v-model="dataForm.mixingTable" clearable filterable multiple placeholder="拌站">
        <el-option v-for="m in mixingTableList" :key="m" :label="m" :value="m"></el-option>
      </el-select>
      <el-form-item label="生产日期">
        <el-date-picker type="date" v-model="dataForm.startDate" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker type="date" v-model="dataForm.endDate" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-checkbox v-model="dataForm.difference">仅显示结算与确认有差异内容</el-checkbox>
      <el-button @click="query" type="primary">查询</el-button>
    </el-form>
    <template slot="append">
      <template v-for="h in headers">
        <el-table-column v-if="h.children" :label="h.label" :key="h.id" header-align="center">
          <tabel-column-template v-for="s in h.children" :key="s.id" :header="s"></tabel-column-template>
        </el-table-column>
        <tabel-column-template v-else :key="h.id" :header="h"></tabel-column-template>
      </template>
    </template>
  </table-view>
</template>

<script>
import TableView from '@/components/templates/table-view'
import TabelColumnTemplate from '@/components/templates/table-column-template'

export default {
  name: 'report-mixingtable-amount',

  components: { TableView, TabelColumnTemplate },

  data () {
    return {
      headers: [
        { id: 1, prop: 'mixingTable', label: '拌站', minWidth: 80 },
        { id: 4,
          label: '类型-固',
          children: [
            { id: 41, prop: 'solidStatementQuantityNumber', label: '结算泵量', minWidth: 70 },
            { id: 42, prop: 'solidStatementPrice', label: '结算泵费', minWidth: 70 },
            { id: 43, prop: 'solidConfirmQuantityNumber', label: '确认泵量', minWidth: 70 },
            { id: 44, prop: 'solidConfirmPrice', label: '确认泵费', minWidth: 70 }
          ]
        },

        { id: 5,
          label: '类型-汽',
          children: [
            { id: 51, prop: 'gasStatementQuantityNumber', label: '结算泵量', minWidth: 70 },
            { id: 52, prop: 'gasStatementPrice', label: '结算泵费', minWidth: 70 },
            { id: 53, prop: 'gasConfirmQuantityNumber', label: '确认泵量', minWidth: 70 },
            { id: 54, prop: 'gasConfirmPrice', label: '确认泵费', minWidth: 70 }
          ]
        },
        { id: 6,
          label: '类型-外固',
          children: [
            { id: 61, prop: 'outSolidStatementQuantityNumber', label: '结算泵量', minWidth: 70 },
            { id: 62, prop: 'outSolidStatementPrice', label: '结算泵费', minWidth: 70 },
            { id: 63, prop: 'outSolidConfirmQuantityNumber', label: '确认泵量', minWidth: 70 },
            { id: 64, prop: 'outSolidConfirmPrice', label: '确认泵费', minWidth: 70 }
          ]
        },
        { id: 7,
          label: '类型-外汽',
          children: [
            { id: 71, prop: 'outGasStatementQuantityNumber', label: '结算泵量', minWidth: 70 },
            { id: 72, prop: 'outGasStatementPrice', label: '结算泵费', minWidth: 70 },
            { id: 73, prop: 'outGasConfirmQuantityNumber', label: '确认泵量', minWidth: 70 },
            { id: 74, prop: 'outGasConfirmPrice', label: '确认泵费', minWidth: 70 }
          ]
        },
        { id: 8,
          label: '总计',
          children: [
            { id: 81, prop: 'totalStatementQuantityNumber', label: '结算总量', minWidth: 70 },
            { id: 82, prop: 'totalStatementPrice', label: '结算总费', minWidth: 70 },
            { id: 83, prop: 'totalConfirmQuantityNumber', label: '确认总量', minWidth: 70 },
            { id: 84, prop: 'totalConfirmPrice', label: '确认总费', minWidth: 70 }
          ]
        }
      ],
      dataForm: {
        startDate: '',
        endDate: '',
        mixingTable: [],
        difference: true
      },
      mixingTableList: []
    }
  },

  methods: {
    query () {
      this.$refs.tableView.queryData()
    },

    getCellClassName ({ row, column, rowIndex, columnIndex }) {
      return ''
    }
  },

  async created () {
    let data = await this.$http({
      url: this.$http.adornUrl('/quantityNumber/info/mixingTables'),
      method: 'post'
    })
    this.mixingTableList = data.datas

    let current = new Date()
    let year = current.getFullYear() - 1
    let month = current.getMonth() > 9 ? current.getMonth() : '0' + current.getMonth()
    let date = '01'
    this.dataForm.startDate = year + '-' + month + '-' + date
  }
}
</script>
